import { render, staticRenderFns } from "./DataInputSwitch.vue?vue&type=template&id=21e1222a&"
import script from "./DataInputSwitch.vue?vue&type=script&lang=js&"
export * from "./DataInputSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports